//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbMiniwishlist from '@/elements/pdp/minicart/mobile/rb-miniwishlist.vue'
// TODO: cleanup methods of old miniwishlist
import { mapGetters, mapActions, mapState } from 'vuex'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import { ACTION_HIDE_SIDEBAR } from '@/scripts/store/actions'
import wcs from '@/scripts/libs/wcs'
import { RB_SIDEBAR_CONTENT } from '@/scripts/constants/css-classes'

export default {
  name: 'rb-sidebar',
  components: {
    RbMiniwishlist,
  },
  computed: {
    ...mapGetters(['showSidebar']),
    ...mapState({
      showMinicart: (state) => state.sidebar.cart.show,
      showWishlist: (state) => state.sidebar.wishlist.show,
    }),
    isPdp() {
      return wcs.isInPdp()
    },
    isMinicartMobile() {
      return this.isMobile && this.isPdp && this.showMinicart && this.showSidebar
    },
    isMobile() {
      return [MOBILE, TABLET].includes(this.$mq)
    },
  },
  updated() {
    if (document.getElementsByClassName(RB_SIDEBAR_CONTENT).length > 0) {
      document.getElementById('sidebar').focus()
      document.getElementById('sidebar').setAttribute('tabindex', '0')
    }
  },
  methods: {
    ...mapActions({
      onClickHandleClose: ACTION_HIDE_SIDEBAR,
    }),
  },
}
